export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9979.cbfdd10e.jpg";